module.exports = __webpack_public_path__ + "media/images/index/care_02_list-08305a118c15dfec6c0065d3307843e5.jpg";